import styled from "styled-components";
import { theme } from "../../../../helpers/theme";


export const Card = styled.div`
  max-width: 80%;
  width: fit-content;
  border: 1px solid #FFFFFF;
  border-radius: 16px;
  padding: 20px;
  margin: 10px 10px;
  display: flex;
  flex-direction: row;

  @media ${theme.device.mobileL} {
    max-width: 60%;
  }

  @media ${theme.device.tablet} {
    max-width: 50%;
  }
  
  @media ${theme.device.laptop} {
    max-width: 30%;
  }
  
  @media ${theme.device.laptopL} {
    margin-bottom: 0px;
    // margin-inline: 20px;
  }

`;

export const CardIcon = styled.img`
  margin-right: 20px;

`;

export const CardTextContainer = styled.div`
  font-size: 14px;
`;

export const CardHeader = styled.h3`
  font-size: 18px;
  
`;

export const CardBody = styled.div`
  height: 4rem;

  @media ${theme.device.laptopL} {
    height: 3rem;
  }
`;

export const CardButton = styled.div`
  font-weight: 700;
  margin-top: 10px;
`;